import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'

export default function InstitutionLayout() {
   const navigate = useNavigate()

   const logout = () => {
      sessionStorage.removeItem('token')
      alert('logout')
      navigate('/login')
   }

   return (
      <Box>
         <AppBar position="static">
            <Toolbar>
               <Typography variant="h6" sx={{ flexGrow: 1 }}>
                  Institution Layout
               </Typography>
               <Button color="inherit" onClick={logout}>
                  Logout
               </Button>
            </Toolbar>
         </AppBar>
         <Box sx={{ p: 2 }}>
            <Outlet />
         </Box>
      </Box>
   )
}
